import React from 'react'
import { Link } from 'react-router-dom'
function ItLeftComp() {
    return (
        <div id="sidebar">
            <nav id="sidebarMenu" className="d-md-block sidebar">
                <div className="position-sticky">
                    <ul className="nav flex-column">
                        <li className="nav-item">
                            <Link className="nav-link active" to="/updateemail">
                                Update Email
                            </Link>
                        </li>
                        {/* <li className="nav-item">
                            <Link className="nav-link active" to="/updateemail">
                                Update Email
                            </Link>
                        </li> */}
                    </ul>
                </div>
            </nav>
        </div>
    )
}

export default ItLeftComp
